import { useSelector } from "react-redux";

import MoleculeNowList from "Components/Molecules/NowContent";
import AtomGridContainer from "Components/Atoms/GridContainer";
import AtomGridChild from "Components/Atoms/GridChild";
import styled, { css } from "styled-components";

import * as enums from "enumerations";
import * as Types from "Types";

const Wrap = styled.div<Types.Default>`
   width: 992px;
   max-width: 100%;
   ${({ css }) => css}
`;

const Link = styled.a`
   & h2 {
      transition-property: color;
      transition-timing-function: ease-in-out;
      transition-duration: 0.3s;
   }
   &:hover h2 {
      color: #7f21f7;
   }
`;

const NowList = styled(MoleculeNowList)<any>``;

export default function NowContents(props: Types.Default) {
   const data: Types.Api.ReducerResponse = useSelector((state: any) => state.nowContents.get);

   return (
      <Wrap css={props.css}>
         <AtomGridContainer
            css={css`
               row-gap: 0;
            `}
         >
            {data.status === enums.api.resolved &&
               data.data?.map((row) => (
                  <AtomGridChild key={row.now_content_id} sizes={{ xxl: 24, xl: 15, l: 12, m: 4, s: 2, xs: 2 }}>
                     <Link href={row.link_uri}>
                        <NowList {...row}></NowList>
                     </Link>
                  </AtomGridChild>
               ))}
         </AtomGridContainer>
      </Wrap>
   );
}
